import { Dispatch } from 'redux';
import { UserTypes } from '.';
import { ApiEndpoints, ActionHandler } from 'Utils';
import { Redirect, Route, useHistory } from 'react-router-dom';

export const welcomeAction = () => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: ApiEndpoints.welcome, method: 'GET', dispatch },

		res => {
			const { data } = res;

			dispatch({ type: UserTypes.Welcome, payload: { data } });
		},
		error => {
			const { data } = error.response;

			dispatch({ type: UserTypes.Errors, payload: { errors: data } });
		},
	);
};

export const loginAction = (email: string, password: string) => (dispatch: Dispatch) => {
	const data = JSON.stringify({ email, password });
	return ActionHandler(
		{ url: ApiEndpoints.login, method: 'POST', dispatch, data },
		res => {
			const { data } = res.data;
			dispatch({ type: UserTypes.Login, payload: { data } });
		},
		error => {
			dispatch({ type: UserTypes.LoginError, payload: { errors: error } });
		},
	);
};

export const loginAdminAction = (email: string, password: string) => (dispatch: Dispatch) => {
	const data = JSON.stringify({ email, password });
	return ActionHandler(
		{ url: ApiEndpoints.login, method: 'POST', dispatch, data },
		res => {
			const { data } = res.data;
			dispatch({ type: UserTypes.ADMIN_LOGIN, payload: { data } });
		},
		error => {
			dispatch({ type: UserTypes.LoginError, payload: { errors: error } });
		},
	);
};

export const registerParent =
	(
		fullName: string,
		email: string,
		password: string,
		childFullName: string,
		dateOfBirth: string,
		gender: string,
		gestation: string,
	) =>
	(dispatch: Dispatch) => {
		const gestationStatus = gestation != 'Term' ? 'preterm' : 'term';
		const genderStatus = gender != 'BOY' ? 'FEMALE' : 'MALE';
		const data = JSON.stringify({
			fullName,
			email,
			password,
			childFullName,
			dateOfBirth,
			gestationStatus,
			genderStatus,
		});
		return ActionHandler(
			{ url: ApiEndpoints.register, method: 'POST', dispatch, data },
			res => {
				const { data } = res;

				dispatch({ type: UserTypes.Registration, payload: { data } });
			},
			error => {
				dispatch({ type: UserTypes.Errors, payload: { errors: error } });
			},
		);
	};

export const GetProfiles = () => (dispatch: Dispatch) => {
	dispatch({ type: UserTypes.LOADING_PROFILE });
	return ActionHandler(
		{ url: ApiEndpoints.profile, method: 'GET', dispatch },
		res => {
			const { data } = res.data;

			dispatch({ type: UserTypes.PROFILE_SUCCESS, payload: { data } });
		},
		error => {
			dispatch({ type: UserTypes.PROFILE_FAIL });
		},
	);
};

export const logoutUser = () => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: ApiEndpoints.logout, method: 'PUT', dispatch },
		res => {
			const { data } = res;

			dispatch({ type: UserTypes.LOGOUT_USER });
		},
		error => {
			dispatch({ type: UserTypes.PROFILE_FAIL });
		},
	);
};
